{
  "version": 1,
  "asset_id": "605243a3-edb2-4213-98fd-db9e2787fa3f",
  "project_id": "ccdae8fb-1850-48c2-affc-657014e2f22c",
  "url": "/__l5e/assets-v1/605243a3-edb2-4213-98fd-db9e2787fa3f/mahirah.jpeg",
  "r2_key": "a/v1/ccdae8fb-1850-48c2-affc-657014e2f22c/605243a3-edb2-4213-98fd-db9e2787fa3f/mahirah.jpeg",
  "original_filename": "mahirah.jpeg",
  "size": 246590,
  "content_type": "image/jpeg",
  "created_at": "2026-07-16T02:38:47Z"
}
